import React, { ReactNode } from 'react';
import clsx from 'clsx';

import * as styles from './ui-form-panel.scss';

export interface UIFormPanelProps {
  title?: string;
  children?: ReactNode;
  styles?: React.CSSProperties;
  className?: string;
}

export const UIFormPanel = ({ title, children, className, ...props }: UIFormPanelProps) => (
  <div className={clsx(styles.container, className)} {...props}>
    {title && (
      <strong className={styles.title} data-testid="UIFormPanel-title">
        {title}
      </strong>
    )}
    {children}
  </div>
);
